export const BetaRibbon = () => {
  return (
    <>
      <div
        style={{
          textAlign: "center",
          padding: "10px 0px",
          fontSize: "10pt",
          width: "100%",
        }}
        className="color_light_blue_500"
      >
        <p style={{ fontWeight: "bold" }} className="text_color_blue_900">
          This application is currently in Beta
        </p>
      </div>
    </>
  );
};
